module.exports = __webpack_public_path__ + "static/media/fondo_sin_nubes_mobile.7dfba12c.png";